module.exports = __webpack_public_path__ + "static/house-oak-b122f2502a2da2e2d6e5b7f4abb765a6.jpg";